// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type AttendeeType from '../contract/AttendeeType';

export default function attendeeType(data: AttendeeType): AttendeeType {
    const result: AttendeeType = {
        __type: 'AttendeeType:#Exchange',
        ...data,
    };

    return result;
}
